let originalTitle = document.title;
let scrollInterval = null;

function startScrollingTitle(message) {
  let scrollText = message + " • ";
  let position = 0;

  stopScrollingTitle(); // clear any existing loop

  scrollInterval = setInterval(() => {
    document.title =
      scrollText.substring(position) + scrollText.substring(0, position);
    position = (position + 3) % scrollText.length;
  }, 50); // speed of scroll in ms
}

function stopScrollingTitle() {
  clearInterval(scrollInterval);
  document.title = originalTitle;
}

function initComeBackTab() {
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      startScrollingTitle("🔥 Come Back! Buy more entries!");
    } else {
      stopScrollingTitle();
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initComeBackTab();
});

document.addEventListener("shopify:section:load", function () {
  initComeBackTab();
});
